import React from 'react';
import { useState } from 'react'
import styled from 'styled-components';
// import styled from 'styled-components';


// import GlobalStyled from '../styles/GlobalStyle';

function ImageSlider({slides, property_info}){
    // let slider = useRef();
    // useEffect(()=>{
    //   slider.current.focus();
    // })

    const [currentImageIndex, setImageIndex] = useState(0)
    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)

    // the required distance between touchStart and touchEnd to be detected as a swipe
    const minSwipeDistance = 50 



    const SlideStyles = {
        // position:"relative",
        height:"100%",
        width:"100%",
        backgroundImage:`url(${slides[currentImageIndex].img}`,
        backgroundSize:"contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition:"center",
        // padding:".5rem 0",
        // margin:".5rem 0",
        // backgroundColor: "DodgerBlue",
        // border:"solid 2px teal"
    }

    const SliderStyles = {
        position:"relative",
        height:"100%"
    }

    const LeftArrow = {
        fontSize:"2.5rem",
        position:"absolute",
        top:"50%",
        left:"40px",
        transform: "translate(0, -50%)",
        zIndex:1,
        cursor:"pointer",
        color:"white"
    }


    const RightArrow = {
        fontSize:"2.5rem",
        position:"absolute",
        top:"50%",
        right:"40px",
        transform: "translate(0, -50%)",
        zIndex:1,
        cursor:"pointer",
        color:"white"
    }

    const innerSoldBox = {
        position:"relative",
        margin:"2.5% 0",
        // border:"solid 2px teal",
        justifyContent:"center",
        alignItems:"center"
    }


    function goToNext(){
        if (currentImageIndex+1 > slides.length - 1) {
            setImageIndex(0)    
        }
        else{
            setImageIndex(currentImageIndex+1)
        }
        
    }

    function goToPrevious(){
        if (currentImageIndex-1 < 0) {
            setImageIndex(slides.length-1)    
        }
        else{
            setImageIndex(currentImageIndex-1)
        }
    }


    const onTouchStart = (e) => {
        setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
        setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

    const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance
    if (isLeftSwipe) { goToNext()}
    if (isRightSwipe) { goToPrevious()}
    }


    document.onkeydown = ((event) => {
        if (event.composed && event.keyCode === 39){
            goToNext()
        }
        if (event.composed && event.keyCode === 37){
            goToPrevious()
        }
        // console.log(event.keyCode)
    })

    return (
        <div style={SliderStyles} >
            {
                 property_info.sold && <SoldBox><div style={innerSoldBox}>Sold!</div></SoldBox>
            }
            {
                 property_info.sale_pending && <SalePendingBox><div style={innerSoldBox}>Sale Pending</div></SalePendingBox>
            }
            <div style={LeftArrow} onClick={goToPrevious}> ❮ </div>
            <div style={RightArrow} onClick={goToNext}> ❯ </div>            
            <div style={SlideStyles} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} ></div>
        </div>
    )
}

export default ImageSlider;


const getHeight = () => {
    if (window.innerWidth < 475) {
        return window.innerHeight * .05
    }
    else if (window.innerWidth >= 450 && window.innerWidth < 650) {
        return window.innerHeight * .05
    }
    else if (window.innerWidth >= 650 && window.innerWidth < 1000) {
        return window.innerHeight * .1
    }
    else if (window.innerWidth >= 1000 && window.innerWidth < 1200) {
        return window.innerHeight * .15
    }
    else if (window.innerWidth >= 1200 && window.innerWidth < 1300) {
        return window.innerWidth * .1
    }
    else if (window.innerWidth >= 1300 && window.innerWidth < 1400) {
        return window.innerHeight * .1
    }
    else{
        let height = window.innerHeight * .95;
        return height * .125
    }
    }

    const getWidth = () => {
        if (window.innerWidth < 475) {
            return 0
        }
        else if (window.innerWidth >= 475 && window.innerWidth < 1000) {
            return -50
        }
        else if (window.innerWidth >= 1000 && window.innerWidth < 1200) {
            return -50
        }
        else if (window.innerWidth >= 1200 && window.innerWidth < 1300) {
            return -50
        }
        else if (window.innerWidth >= 1300 && window.innerWidth < 1510) {
            return 0
        }
        else if (window.innerWidth >= 1510 && window.innerWidth < 1600) {
            return 150
        }
        else{
            return 300
        }
        }

        const Width = () =>{
            if (window.innerWidth < 475) {
                return 35
            }
            else if (window.innerWidth >= 475 && window.innerWidth < 1200) {
                return 35
            }
            else if (window.innerWidth >= 1200 && window.innerWidth < 1300) {
                return 30
            }
            else if (window.innerWidth >= 1300 && window.innerWidth < 1400) {
                return 25
            }
            else if (window.innerWidth >= 1400 && window.innerWidth < 1600) {
                return 25
            }
            else{
                return 20
            }
        }

    const SoldBox = styled.div`
        background-color:red;
        height:2rem;
        width:${Width}%;
        top:${getHeight}px;
        left:${getWidth}px;
        position:absolute;
        transform:rotate(315deg);
        color:white;
        level:0;
        border-radius:4px;
        font-family: Arial, Helvetica, sans-serif;
        font-weight:900;
    `;

    const SalePendingBox = styled.div`
    background-color:red;
    height:3rem;
    width:${Width}%;
    top:${getHeight}px;
    left:${getWidth}px;
    position:absolute;
    transform:rotate(315deg);
    color:white;
    level:0;
    border-radius:4px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight:900;
`;